import React, { useState } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import UserIcon from '../../../../../icons/user.svg';
import PinLocationIcon from '../../../../../icons/pin-location.svg';
import CalendarIcon from '../../../../../icons/calendar1.svg';
import ExpandMoreIcon from '../../../../../icons/expand-more.svg';
import HSA from "../../icons/HSA.svg"
import Button from '@material-ui/core/Button';
import Age from '../../../../Helpers/Dates/Age';
import PropTypes from 'prop-types';
import Collapse from '@material-ui/core/Collapse';

import './CollapsibleBasicInfoSummary.scss'

export function BasicInfoSummary(props) {
    const age = props.birthdate ? Age(props.birthdate) : null;
    const hsa = props.hsaAccount ? "HSA" : "Non-HSA";
    const data = [
        {
            icon: PinLocationIcon,
            label: 'State',
            text: props.state
        },
        {
            icon: UserIcon,
            label: 'Gender',
            text: props.gender === 'F' ? 'Female' : props.gender === 'M' ? 'Male' : null
        },
        {
            icon: CalendarIcon,
            label: 'Age',
            text: age
        },
        {
            icon: HSA,
            label: 'HSA',
            text: hsa
        },
    ];
    return (
        <div className="quote-basic-info-summary d-flex flex-wrap justify-content-center">
            {data.map((d, index) => d.text &&
                <div key={index} className={`item ${d.skip ? 'd-none' : ''}`}>
                    <SvgIcon role="img" component={d.icon} className="mx-auto" aria-hidden={false} aria-label={d.label} id={`${d.label}-${index}`} color="primary" />
                    <div className="mx-auto label">{d.text}</div>
                </div>
            )
            }
        </div>
    )
}
export function CollapsibleBasicInfoSummary(props) {
    const [expanded, setExpanded] = useState(true);

    return (
        <div className="collapsible-basic-info-summary">
            <div className="action-block">
                <Button variant="text" className="expand" onClick={() => setExpanded(!expanded)} aria-expanded={expanded}>
                    Summary
                    <SvgIcon component={ExpandMoreIcon} className={expanded ? 'expanded' : ''} />
                </Button>
                <Button variant="text" className="edit-btn" color="primary" onClick={props.editLinkOnClick}>Edit</Button>
            </div>
            <div>
                <Collapse in={expanded} className="w-100">
                    <BasicInfoSummary {...props} />
                </Collapse>
            </div>
        </div>
    )
}

BasicInfoSummary.propTypes = {
    gender: PropTypes.string,
    state: PropTypes.string,
    birthdate: PropTypes.string.isRequired,
    tobacco: PropTypes.string,
    height: PropTypes.string,
    weight: PropTypes.string,
};

CollapsibleBasicInfoSummary.propTypes = {
    gender: PropTypes.string,
    state: PropTypes.string,
    birthdate: PropTypes.string.isRequired,
    tobacco: PropTypes.string,
    height: PropTypes.string,
    weight: PropTypes.string,
    editLinkOnClick: PropTypes.func,
};


// WEBPACK FOOTER //
// ./src/components/Quoters/Aflac/Helpers/Input/CollapsibleBasicInfoSummary.js